// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function FormHelperText() {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: '0',
          marginRight: '0'
        }
      }
    }
  };
}
